import React, { useEffect, useMemo, useState } from "react";
import { getStoreSettings } from "../../api/api";
import AnnouncementBanner from "./AnnouncementBanner";
import AnnouncementModal from "./AnnouncementModal";

function toDate(value) {
  if (!value) return null;

  // Firestore Timestamp shapes can vary in JSON
  if (value.toDate && typeof value.toDate === "function") return value.toDate();
  if (typeof value.seconds === "number") return new Date(value.seconds * 1000);
  if (typeof value._seconds === "number") return new Date(value._seconds * 1000);

  if (typeof value === "string" || typeof value === "number") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (value instanceof Date) return value;

  return null;
}

function isAnnouncementActive(a) {
  if (!a || !a.enabled) return false;

  const now = new Date();
  const start = toDate(a.startAt);
  const end = toDate(a.endAt);

  if (start && now < start) return false;
  if (end && now > end) return false;

  return true;
}

export default function AnnouncementManager() {
  const [settings, setSettings] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const data = await getStoreSettings();
        if (mounted) setSettings(data);
      } catch (e) {
        // Fail silently; announcement is non-critical
        console.warn("Failed to load store settings:", e);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const announcement = useMemo(() => {
    const a = settings?.announcement;
    if (!isAnnouncementActive(a)) return null;
    return a;
  }, [settings]);

useEffect(() => {
  if (!announcement) return;
  if (!announcement.showPopup) return;

  // IMPORTANT: ensure announcement.id exists in DB (set via Telegram)
  const announcementId =
    announcement.id ||
    String(announcement.updatedAt?._seconds || announcement.updatedAt?.seconds || "") ||
    String(announcement.message || "");

  const storageKey = `announcement_seen_${announcementId}`;
  const seen = window.localStorage.getItem(storageKey) === "1";

  if (!seen) {
    setModalOpen(true);
    window.localStorage.setItem(storageKey, "1");
  }
}, [announcement]);

  if (!announcement) return null;

  return (
    <>
      {announcement.showBanner ? (
        <AnnouncementBanner
          announcement={announcement}
          onOpen={() => setModalOpen(true)}
        />
      ) : null}

      <AnnouncementModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        announcement={announcement}
      />
    </>
  );
}